import { Notification } from '@elements/notification';
import { i18n } from '@i18n';
import { useCheckoutStore } from '@store';
import { testProps } from '@utils';

export const GooglePayNotification = () => {
  const googlePaymentData = useCheckoutStore(state => state?.googleCreditCardDetails);
  const cardNumber = googlePaymentData?.cardNumber;
  const googleToken = googlePaymentData?.paymentToken;

  if (!cardNumber || !googleToken) {
    return null;
  }

  return (
    <Notification
      {...testProps('google-pay-notification')}
      variant="success"
      header={i18n.t('confirmation.googlePayNotification.title', { cardNumber })}
      body={i18n.t('confirmation.googlePayNotification.description')}
    />
  );
};
